import { $, $$ } from '../../../shared/js/utils/dom';

const fileInputs = $$('.input-file:not(.input-file--no-js)');

fileInputs.forEach(fileInput => {
  const input = $('.input-file__input', fileInput);
  const status = $('.input-file__status', fileInput);
  const button = $('.input-file__button', fileInput);
  const origStatusText = status.textContent;

  input.addEventListener('change', function () {
    status.textContent = status.textContent =
      this.files &&
      ([...this.files].map(file => file.name).join(', ') || origStatusText);
  });
  input.addEventListener('focusin', function () {
    button.classList.add('has-focus');
  });
  input.addEventListener('focusout', function () {
    button.classList.remove('has-focus');
  });
});
